import CustomPalette from '@/theme/CustomPalette'

export const sidebarContainerStyles = {
  backgroundColor: CustomPalette.SecondaryCloud,
  display: 'flex',
  flexDirection: 'column' as const,
  flex: 1,
  minHeight: 0,
  overflowX: 'hidden' as const,
  overflowY: 'auto' as const,
}

export const sectionHeaderButtonStyles = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: 72,
  px: 2.5,
  py: 1.2,
}

export const sectionHeaderContentStyles = {
  flex: 1,
  minWidth: 0,
  pr: 1,
}

export const sectionTitleStyles = {
  color: CustomPalette.NightBlue200,
  fontSize: '16px',
  lineHeight: '22px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap' as const,
}

export const sectionSubtitleStyles = {
  color: CustomPalette.SecondaryNightBlue700,
  fontSize: '13px',
  lineHeight: '18px',
}

export const itemButtonStyles = {
  minHeight: 56,
  px: 2.5,
  py: 0.75,
  '&.Mui-selected': {
    backgroundColor: '#D7D9F7',
    borderRight: '4px solid #463ED7',
    color: '#363752',
  },
  '&:hover': {
    backgroundColor: '#D7D9F7',
    '& .MuiTypography-root': {
      color: '#363752',
    },
  },
}

export const itemTextStyles = {
  '& span': {
    fontSize: '16px',
    color: '#151830',
  },
}

export const itemIconStyles = {
  minWidth: 0,
  mr: 1.8,
  color: CustomPalette.SecondaryNightBlue700,
  '& svg': {
    fontSize: '18px',
  },
}

export const sectionDividerStyles = {
  borderColor: CustomPalette.SecondaryNightBlue200,
}

export const collapsedItemButtonStyles = {
  minHeight: 56,
  px: 0,
  py: 0.5,
  justifyContent: 'center',
  '&.Mui-selected': {
    backgroundColor: '#D7D9F7',
    borderRight: '4px solid #463ED7',
    color: '#363752',
  },
  '&:hover': {
    backgroundColor: '#D7D9F7',
  },
}

export const collapsedItemIconStyles = {
  minWidth: 0,
  mr: 0,
  color: CustomPalette.NightBlue200,
  '& svg': {
    fontSize: '26px',
  },
}

export const collapsedSectionInitialStyles = {
  color: CustomPalette.SecondaryNightBlue700,
  fontSize: '12px',
  lineHeight: '16px',
  textTransform: 'uppercase' as const,
  textAlign: 'center' as const,
}

export const bottomAccountSectionStyles = {
  borderTop: `1px solid ${CustomPalette.SecondaryNightBlue200}`,
}

export const userNameContainerStyles = {
  px: 2.5,
  py: 2,
}

export const userNameStyles = {
  color: CustomPalette.NightBlue200,
  fontSize: '16px',
  lineHeight: '22px',
}
